module.exports = __webpack_public_path__ + "images/magic-big-36b03192.jpg";